<template>
  <div class="account-change-password">
    <h3 class="account-change-password__title">
      {{ $tAccountProfileChangePassword('title') }}
    </h3>
    <div class="account-change-password__inputs">
      <BaseInput v-model="inputs.old_password.value"
                 :error="inputs.old_password.error"
                 :label="$tAccountProfileChangePassword('input_old_password')"
                 type="password"
                 class="account-change-password__input"/>
      <BaseInput v-model="inputs.password.value"
                 :error="inputs.password.error"
                 :label="$tAccountProfileChangePassword('input_password')"
                 type="password"
                 class="account-change-password__input"/>
      <BaseInput v-model="inputs.re_password.value"
                 :error="inputs.re_password.error"
                 :label="$tAccountProfileChangePassword('input_re_password')"
                 type="password"
                 class="auth-agent-login__input"/>
    </div>
    <BaseAlert :value="overallErrorsMix"
               class="account-change-password__error  _warning"/>
    <button v-if="pending"
            disabled
            class="account-change-password__btn  base-btn  base-btn--blue">
      {{ $tAccountProfileChangePassword('btn_save') }}
      <BasePreloader/>
    </button>
    <button v-else
            @click.prevent="save"
            class="account-change-password__btn  base-btn  base-btn--blue">
      {{ $tAccountProfileChangePassword('btn_save') }}
    </button>
  </div>
</template>

<script>
  import {http} from "@/axios"
  import formMixins from "@/mixins/formMixins"

  export default {
    name: 'AccountProfileChangePassword',
    mixins: [formMixins],
    data() {
      return {
        pending: false,

        inputs: {
          old_password: {
            value: null
          },
          password: {
            value: null
          },
          re_password: {
            value: null
          },
        }
      }
    },
    methods: {
      save() {
        this.pending = true

        this.resetErrorsMix(this.inputs)
        const sendData = this.createSendDataMix(this.inputs)

        http.patch('/api/cabinet/company-profile-v2/password-change', sendData)
            .then(() => {
              this.$vModal.close()
              this.$vModal.open('successfully-sent', {
                title: this.$tAccountProfileChangePassword('success_title'),
              })
            })
            .catch(e => {
              this.errorHandlerMix(e, this.inputs)
            })
            .finally(() => {
              this.pending = false
            })
      }
    }
  }
</script>

<style lang="less">

</style>
